
import {  FormGroup, ValidatorFn  } from '@angular/forms';
import {faUserPlus,faUserTimes, faUnlock, faLock, faSearch,
  faPlus, faCog, faTimes, faCloudUploadAlt,faSave,faArrowLeft,faTrashAlt,faFileArchive,
faFileCode, faStopCircle, faPlayCircle, faPencilAlt} from "@fortawesome/free-solid-svg-icons"

export abstract class BaseComponent {
  faUserPlus=faUserPlus;
  faUserTimes=faUserTimes;
  faUnlock = faUnlock;
  faLock = faLock;
  faSearch = faSearch;
  faPlus=faPlus;
  faCog=faCog;
  faTimes=faTimes;
  faCloudUploadAlt=faCloudUploadAlt;
  faSave=faSave;
  faArrowLeft=faArrowLeft;
  faTrashAlt=faTrashAlt;
  faFileArchive=faFileArchive;
  faFileCode=faFileCode;
  faStopCircle = faStopCircle;
  faPlayCircle = faPlayCircle;
  faPencilAlt = faPencilAlt;

  public config: any;


    public  emailPattern = /^[_a-z0-9-\+-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;
    public letterPattern = /^[a-zA-Zа-яёА-Я-\s]+$/;
    public integerPattern = /^([+-]?[1-9]\d*|0)$/;
    public onlyNumPattern = /^[0-9]\d*$/;  // /^[0-9]+$/;
    public floatPattern = /[+-]?([0-9]*[.])?[0-9]+/;
    public utmPattern = /^[a-zA-Z0-9_]+$/;
    public imageExtentionPattern = /(.*)+(\.png|\.jpe?g)+$/i;
    public linkPattern = '(https://){1}([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

    // (?=.*[a-z]) - A positive look-ahead to require a lowercase letter
    // (?=.*[A-Z]) - A positive look-ahead to require an uppercase letter
    // (?=.*[0-9]) - A positive look-ahead to require a digit
    // (?=.*[ -/:-@\[-{-~])` - A positive look-ahead to require a special character
    // .{6,64} - Any character (but a newline), 6 to 64 occurrences
    // $ - End of string.
    public passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ -/:-@\[-`{-~]).{6,64}$/;

    //просто какой то паттерн для того что бы открылось в IE
    // public  emailPattern =  /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    // public letterPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    // public integerPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    // public floatPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

    constructor(){
      this.config = {
        labelField: 'label',
        valueField: 'value',
        searchField: 'label',
        highlight: false,
        create: false,
        persist: true,
        //plugins: ['dropdown_direction', 'remove_button'],
        dropdownDirection: 'down',
        maxItems: 1
      };
    };

     /** показать или убрать прелоадер */
     public setLoading(isLoading: boolean): void {
        if (isLoading) {
            (<any>window).$("#preloader").css('display', 'flex');
        } else {
            (<any>window).$("#preloader").hide();
        }
    }

    public copyObject(object: any):any{
        return JSON.parse(JSON.stringify(object));
    }

    public  isHasError(formAndDivname : any ,func : any) {
        return !formAndDivname.$pristine && !formAndDivname.$focused && func.isValid;
    }
    public IsNotEmpty(val : any): IValidationResult {
        if(val!="" && val!=undefined && val!=null){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Поле обязательно к заполнению"
            };
        }
    }

    public NotEmpty(val : any): IValidationResult {
        if(!!(val.replace('/\s/g','')) || (!val)){
            return {
                isValid:false,
                errorText:"Поле не может быть пустым"
            }
        }
        else{
            return {
                isValid:true,
                errorText:""
            }
        }
    }

    public IsNumber(val : any): IValidationResult {
        if(!isNaN(val) && isFinite(val)){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Введите число"
            };
        }
    }

    public IsNumAndInteger(val : any): IValidationResult {
        if(typeof(val)=="string"){
            try{
                val=+val;
            }
            catch{
                return {
                    isValid: false,
                    errorText: "Введите целое число"
                };
            }
        }
        if(this.IsNumber(val) && Number.isInteger(val)){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Введите целое число"
            };
        }
    }

    public IsInteger(val : any): IValidationResult {
        if(typeof(val)=="string"){
            try{
                val=+val;
            }
            catch{
                return {
                    isValid: false,
                    errorText: "Введите целое число"
                };
            }
        }
        if( Number.isInteger(val)){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Введите целое число"
            };
        }
    }
    public MaxInteger(val : any,limit:number): IValidationResult {
        if(typeof(val)=="string"){
            try{
                val=+val;
            }
            catch{
                return {
                    isValid: false,
                    errorText: "Введите число не превыщающее " + limit
                };
            }
        }

        if( val<=limit){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Введите число не превыщающее " + limit
            };
        }
    }

    public MinInteger(val : any,limit:number): IValidationResult {
        if(typeof(val)=="string"){
            try{
                val=+val;
            }
            catch{
                return {
                    isValid: false,
                    errorText: "Введите число не меньше " + limit
                };
            }
        }
        if(val>=limit){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Введите число не меньше " + limit
            };
        }
    }

    public MaxLenString(val : string,limit:number): IValidationResult {
        if(val.length<=limit){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Максимальная длина текста " + limit
            };
        }
    }

    public MinLenString(val : string,limit:number): IValidationResult {
        if(val.length>=limit){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Минимальная длина текста " + limit
            };
        }
    }

    public IsEmail(val : any): IValidationResult {
        var re = this.emailPattern;
        if(re.test(val)){
            return {
                isValid: true,
                errorText: ""
            };
        }
        else{
            return {
                isValid: false,
                errorText: "Не правильный email"
            };
        }
    }



    public validateString(val : any, max=-1,min=-1): IValidationResult{
        var me = this;
        return !me.IsNotEmpty(val).isValid ? me.IsNotEmpty(val) :
        max !=1 && !me.MaxLenString(val, max).isValid ? me.MaxLenString(val, 100) :
        min !=1 && !me.MinLenString(val, min).isValid ? me.MaxLenString(val, 100) :
            {
                isValid: true,
                errorText: ""
            };
    }

    public  validateNumber(val : any,isOnlyInt = false, max=null,min=null) {
        var me = this;
        return !me.IsNotEmpty(val).isValid ? me.IsNotEmpty(val) :
        isOnlyInt && !me.IsNumAndInteger(val).isValid ? me.IsNumAndInteger(val) :
        !isOnlyInt && !me.IsNumber(val).isValid ? me.IsNumber(val) :
        max !=1 && !me.MaxInteger(val, max).isValid ? me.MaxLenString(val, 100) :
        min !=1 && !me.MaxInteger(val, min).isValid ? me.MaxLenString(val, 100) :
            {
                isValid: true,
                errorText: ""
            };
    }


    public validateStrEmail(val : any, max=-1,min=-1): IValidationResult{
        var me = this;
        return !me.IsNotEmpty(val).isValid ? me.IsNotEmpty(val) :
        max !=1 && !me.MaxLenString(val, max).isValid ? me.MaxLenString(val, 100) :
        min !=1 && !me.MinLenString(val, min).isValid ? me.MaxLenString(val, 100) :
        !me.IsEmail(val).isValid ? me.IsEmail(val) :
            {
                isValid: true,
                errorText: ""
            };
    }



    public  elemIsInvalid(elem : any) : boolean {
       return  elem.dirty && !elem.untouched && elem.invalid;
    }

    public textErrorStr(elem : any,namepattern = null)
    {
        if(this.elemIsInvalid(elem)){
            return   elem.errors.required ? "Поле обязательно для заполнения" :
            elem.errors.maxlength!=undefined ? ("Максимальная длина "+elem.errors.maxlength.requiredLength) :
            elem.errors.minlength!=undefined ? ("Минимальная длина "+elem.errors.minlength.requiredLength) :
            elem.errors.pattern!=undefined && namepattern!=null ? ("Некорректный "+namepattern) :
            elem.errors.pattern!=undefined ? ("Необходимо ввести домен в формате: 'https://domain.com'") :
            elem.errors.uniqueInvalid!=undefined ? ("Значения должны быть уникальны") :
            elem.errors.existUtmName!= undefined ? ("Токен с таким именем используется в utm метках") :
            elem.errors.spaceInUtmName!= undefined ? ("Имя токена не должено содержать пробелов") :
            elem.errors.onlyLatinUtmName!= undefined ? ("Имя токена должно быть записано только на латинице") :
            elem.errors.illegalLink!= undefined ? ("Данный домен отсутствует в списке разрешенных") :
            elem.errors.maxLenBlackoutMsg!= undefined ? ("Максимальная длина слова в сообщении 20") :
             "";
        }
        return "";
    }

    public textErrorNum(elem : any,namepattern = null)
    {
        if(this.elemIsInvalid(elem)){
            return  elem.errors.required ? "Поле обязательно для заполнения" :
            elem.errors.max!=undefined ? ("Максимальное значение "+elem.errors.max.max) :
            elem.errors.min!=undefined ? ("Минимальное значение "+elem.errors.min.min) :
            elem.errors.pattern!=undefined && namepattern!=null ? ("Число должно иметь "+namepattern+" значение"):"";

        }
        return "";
    }

    public GetErrorMessageText(defaultText:string, responce:any){

        if(responce && responce.error && responce.error.errorMsgs && responce.error.errorMsgs[0]){
           return responce.error.errorMsgs[0];
        }

        return defaultText;
    }

  /**
   * Marks all controls in a form group as touched and dirty
   * @param formGroup - The form group to touch and to dirty
   */
  public markFormGroupTouchedAndDirty(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.markAsDirty();
      control.updateValueAndValidity();

      if (control.controls) {
        this.markFormGroupTouchedAndDirty(control);
      }
    });
  }

}

export interface IValidationResult {
    /**
     * Валидно/невалидно
     */
    isValid: boolean;
    /**
     * Текст сообщения об ошибке
     */
    errorText: string;
}



// WEBPACK FOOTER //
// ./src/app/core/base/base.component.ts